import React from 'react';

const Logo = ({ className = "", size = "medium" }) => {
  // Define dynamic size classes for responsiveness
  const sizeClasses = {
    small: "h-8 w-8 sm:h-10 sm:w-10",
    medium: "h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14",
    large: "h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20",
    xlarge: "h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24",
  };

  return (
    <div
      className={`flex items-center space-x-2 sm:space-x-3 ${className}`}
    >
      {/* Image logo */}
      <img
        src="/logo.png"
        alt="Vihaan Herbals"
        className={`${sizeClasses[size]} object-contain`}
        onError={(e) => {
          // fallback to text logo if image fails to load
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />

      {/* Text-based fallback logo */}
      <div
        className={`${sizeClasses[size]} bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center text-white font-bold text-lg hidden`}
        style={{ display: 'none' }}
      >
        VH
      </div>

      {/* Logo text */}
      <div className="flex flex-col">
        <span
          className="text-base sm:text-lg md:text-2xl font-bold text-gray-900 leading-tight"
          style={{ fontFamily: 'Montserrat, Inter, sans-serif' }}
        >
          Vihaan Herbals
        </span>
        <span
          className="text-[10px] sm:text-xs md:text-base text-green-600 font-medium tracking-wide"
          style={{ fontFamily: 'Poppins, Inter, sans-serif', letterSpacing: '0.13em' }}
        >
          NATURE'S CURE IN HERBS
        </span>
      </div>
    </div>
  );
};

export default Logo;
